import type Stripe from "stripe";
import type {
  CreateOrganizationEventTicketDto,
  UpdateOrganizationEventTicketDto,
} from "../../../../dtos";
import type { Endpoint } from "../../../../endpoints";
import type { Base, OrganizationEvent } from "../../..";

export type OrganizationEventTicket = Base & {
  name: string;
  description?: string;
  price: Stripe.Price;
  product: Stripe.Product;
  fee: number;
  quantity: number;
  type: OrganizationEventTicketType;
  category: OrganizationEventTicketCategory;
  externalId?: string;
  isVisible: boolean;
  isFeesIncluded: boolean;
  startAt?: Date;
  endAt?: Date;
  event: OrganizationEvent;
};

export enum OrganizationEventTicketType {
  ETicket = "e-ticket",
  Other = "other",
}

export enum OrganizationEventTicketCategory {
  Entry = "entry",
  Package = "package",
  Meal = "meal",
  Drink = "drink",
  Parking = "parking",
  Accommodation = "accommodation",
  Camping = "camping",
  Locker = "locker",
  Shuttle = "shuttle",
  Other = "other",
}

export type OrganizationEventTicketEndpoints =
  | Endpoint<
      "GET",
      "/organizations/@:organizationSlug/events/:eventSlug/tickets",
      OrganizationEventTicket[]
    >
  | Endpoint<
      "GET",
      "/organizations/@:organizationSlug/events/:eventSlug/tickets/:ticketId",
      OrganizationEventTicket
    >
  | Endpoint<
      "POST",
      "/organizations/@:organizationSlug/events/:eventSlug/tickets",
      OrganizationEventTicket,
      CreateOrganizationEventTicketDto
    >
  | Endpoint<
      "PUT",
      "/organizations/@:organizationSlug/events/:eventSlug/tickets/:ticketId",
      OrganizationEventTicket,
      UpdateOrganizationEventTicketDto
    >
  | Endpoint<
      "DELETE",
      "/organizations/@:organizationSlug/events/:eventSlug/tickets/:ticketId",
      OrganizationEventTicket[],
      null
    >;
